import React from 'react';
import { GET_CONVERSATIONS_ENDPOINT, TimeInterval } from '../../types/AnalyticsApi';
import { DataPoint, HandledData, TimeSeriesDataPoint } from '../../types/CompositeDataProvider';
import CompositeDataProvider from '../DataProviders/CompositeDataProvider';
import Legend from '../Legends/Legend';
import LineChartContainer from '../LineChart/LineChartContainer';
import ChartSectionContainer from '../Section/ChartSectionContainer';
import SectionChart from '../Section/SectionChart';
import SectionHeader from '../Section/SectionHeader';

interface DashboardConversationsChartProps {
    countryCode?: string[] | null;
    from?: string | null;
    to?: string | null;
    companyId?: string[] | null;
    departmentId?: string[] | null;
    total?: boolean;
    interval: TimeInterval;
}

const addToInterval = (intervals: Map<number, DataPoint[]>, date: number, key: string, value: number) => {
    if (!intervals.has(date)) {
        intervals.set(date, []);
    }

    intervals.get(date)?.push({
        key,
        value
    });
};

const dataMerger = (dataSets: HandledData[]) => {
    let mergedData: TimeSeriesDataPoint[] = [];
    let intervals = new Map<number, DataPoint[]>();

    for (let dataSet of dataSets) {
        if (!dataSet.data) {
            continue;
        }

        for (let data of dataSet.data) {
            addToInterval(intervals, new Date(Date.parse(data.key)).getTime(), dataSet.id, data.value);
        }
    }

    intervals.forEach((value, key) => {
        mergedData.push({
            key: new Date(key),
            value
        });
    });

    return mergedData;
};

const DashboardConversationsChart: React.FC<DashboardConversationsChartProps> = (props) => {
    let { total, ...options } = props;

    return (
        <ChartSectionContainer>
            <SectionHeader>{!total && 'Δ'} Total Conversations Created</SectionHeader>

            <Legend
                items={[
                    {
                        name: 'Chat',
                        color: '#d9a5ff'
                    },
                    {
                        name: 'Group',
                        color: '#ffeda5'
                    },
                    {
                        name: 'Case',
                        color: '#5cefff'
                    }
                ]}
            />

            <SectionChart>
                <CompositeDataProvider
                    dataFormat="TIME_SERIES"
                    sources={[
                        {
                            id: 'Case',
                            src: GET_CONVERSATIONS_ENDPOINT,
                            options: {
                                conversationType: ['Case']
                            },
                            handler: (res: any) => res.data
                        },
                        {
                            id: 'Group',
                            src: GET_CONVERSATIONS_ENDPOINT,
                            options: {
                                conversationType: ['Group']
                            },
                            handler: (res: any) => res.data
                        },
                        {
                            id: 'Chat',
                            src: GET_CONVERSATIONS_ENDPOINT,
                            options: {
                                conversationType: ['Chat']
                            },
                            handler: (res: any) => res.data
                        }
                    ]}
                    merger={dataMerger}
                    options={options}
                    updateOnEventStrings={['CONVERSATION_CREATED']}
                    throttleMilliseconds={10000}
                >
                    <LineChartContainer
                        margin={{
                            top: 10,
                            right: 30,
                            left: 75,
                            bottom: 40
                        }}
                        diverging={!total}
                    />
                </CompositeDataProvider>
            </SectionChart>
        </ChartSectionContainer>
    );
};

DashboardConversationsChart.defaultProps = {
    total: false
};

export default DashboardConversationsChart;
